import React, { useEffect } from 'react'
import RegistrationForm from '../components/forms/RegistrationForm';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Registration = () => {
  const authState = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if(authState.isAuthenticated) {
      navigate("/submissions")
    }
  }, [])

  return (
    <>
      <RegistrationForm />
    </>
  )
}

export default Registration;